import React, { useEffect, useMemo, useState } from "react";

import { updateTrainingHistory } from "app/_services/UserManagement/EmployeeService";
import { Modal, Button } from "react-bootstrap";

import toastr from "toastr";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiEdit3 } from "react-icons/fi";
import { trainingHistoryValidation } from "../Constant";
import EmployeeTrainingHistoryForm from "./EmployeeTrainingHistoryForm";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";

function TrainingHistoryList({
  data,
  getFormData,
  siteList,
  onListHistory,
  searchFlag,
  isNoPagination,
}) {
  const [siteHistoryList, setSiteHistoryList] = useState([]);

  // Edit Site History Modal
  const [editHistory, setEditHistory] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [historyError, setHistoryError] = useState({});

  /******************* Site History Modal**********************/
  const onClickEditHistory = (row) => {
    setEditHistory(true);
    console.log("/*/*/*/*/*/rowTra", row);
    setSelectedHistory({
      ...row,
      siteId: row.siteId || "",
      startDate: row.startDate || "",
      endDate: row.endDate || "",
      newBasicTrainingDesignation: row?.trainingDesgnationId,
      newTrainingEligibility: row?.trainingEligibility.toLowerCase(),
      effectiveDate: row?.startDate,
    });
  };

  const onHideSiteHistory = () => {
    setSiteHistoryList([]);
  };

  const siteHistoryColumns = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "trainingDesignationName",
        text: "Training Designation",
        sort: true,
      },

      {
        dataField: "trainingEligibility",
        text: "Training Eligibility",
        sort: true,
      },
      {
        dataField: "createdAtView",
        text: "Date",
        sort: true,
      },
      {
        dataField: "trainingDueDateView",
        text: "Training Due Date",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Training Status",
        sort: true,
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          if (
            Array.isArray(siteHistoryList) &&
            siteHistoryList.length > 0 &&
            row.id === siteHistoryList[0].id &&
            row?.editFlag
          ) {
            return (
              <div className="actionIconsGroup">
                <CustomTooltip tooltip="Edit">
                  <span
                    onClick={() => onClickEditHistory(row)}
                    className="icons btn-icon font-20 text-cyanBlue"
                  >
                    <FiEdit3 />
                  </span>
                </CustomTooltip>
              </div>
            );
          }
        },
      },
    ],
    [siteHistoryList]
  );

  /******************* Add Site  Modal******************/
  const onChangeHistory = ({ target: { name, value, type, checked } }) => {
    setSelectedHistory((prev) => ({
      ...prev,

      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onHideHistory = () => {
    setEditHistory(false);
    setSelectedHistory(null);
  };

  const onSubmitEditHistory = async (e) => {
    e.preventDefault();

    let errorObj = trainingHistoryValidation(selectedHistory);
    setHistoryError(errorObj);

    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    let response = await updateTrainingHistory({
      id: selectedHistory.id,
      newBasicTrainingDesignation: selectedHistory.newBasicTrainingDesignation,
      newTrainingEligibility: selectedHistory.newTrainingEligibility,
      effectiveDate: selectedHistory.effectiveDate,
    });

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");
    onHideHistory();
    onHideSiteHistory();
    if (getFormData) getFormData();
  };

  /************** useMemo ***************/
  useEffect(() => {
    setSiteHistoryList(JSON.parse(JSON.stringify(data)));
  }, [data]);

  return (
    <div>
      {/* Site History */}
      <div className="mt-2 mb-4">
        {!onListHistory && <h5>History</h5>}

        <SearchBootstrapTable
          tableName={"site-history"}
          data={siteHistoryList}
          columns={siteHistoryColumns?.filter(
            (d) => d.dataField !== "create" || !onListHistory
          )}
          tableDownloadFlag={false}
          searchFlag={searchFlag}
          isNoPagination={isNoPagination}
        />
      </div>

      {/* Edit Site History Modal */}
      <Modal show={editHistory} onHide={onHideHistory} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Edit History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <EmployeeTrainingHistoryForm
            siteList={siteList}
            form={selectedHistory}
            onChange={onChangeHistory}
            error={historyError}
          />
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <div>
            <Button variant="secondary" onClick={() => onHideHistory()}>
              Back
            </Button>
            <Button className="ml-2" onClick={onSubmitEditHistory} variant="primary">
              Update
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TrainingHistoryList;
